<div class="container">
    <div class="delete-attribute-group-content">
        <p class="warning">Are you sure you want to delete {{ data.categoryData.id }}?</p>
        <div class="button-container">
            <button
                mat-raised-button
                matTooltip="Cancel Deleting Attribute Group"
                style="margin-right: 60px;"
                type="button"
                (click)="onNoClick()"
                class="button"
            >Cancel</button>
            <button
                mat-raised-button
                matTooltip="Delete Attribute Group"
                type="button"
                (click)="OnSubmit()"
                class="button"
            >Continue</button>
        </div>
    </div>
</div>

